export default "__VITE_ASSET__QkhBWWii__"